import { fromJS } from 'immutable';
export var SET_ANALYTIC_CAMERA_LIST = 'camera/SET_ANALYTIC_CAMERA_LIST';
export var SET_CCTV_CAMERA_LIST = 'camera/SET_CCTV_CAMERA_LIST';
export var SET_ROAD_CAMERA_LIST = 'camera/SET_ROAD_CAMERA_LIST';
export var SET_NVR_LIST = 'camera/SET_NVR_LIST';
export var SET_TIPC_CCTV_CAMERA_LIST = 'camera/SET_TIPC_CCTV_CAMERA_LIST';
export var SET_NVR_OPTIONS = 'camera/SET_NVR_OPTIONS';
export var SET_HARBOR_OPTIONS = 'camera/SET_HARBOR_OPTIONS';
export var SET_ANALYTIC_CAMERA_SORT = 'camera/SET_ANALYTIC_CAMERA_SORT';
export var SET_CCTV_SORT = 'camera/SET_CCTV_SORT';
export var SET_ROAD_SORT = 'camera/SET_ROAD_SORT';
export var SET_NVR_SORT = 'camera/SET_NVR_SORT';
export var SET_TIPC_SORT = 'camera/SET_TIPC_SORT';
export var SET_DIALOG_INFO = 'camera/SET_DIALOG_INFO';
export var CLEAR_DIALOG_INFO = 'camera/CLEAR_DIALOG_INFO';
export var SET_NVR_IP = 'camera/SET_NVR_IP'; // export const OPEN_ANALYTIC_CAMERA_EDIT = 'camera/OPEN_ANALYTIC_CAMERA_EDIT'
// export const SET_DIALOG_MODE = 'camera/SET_DIALOG_MODE'
// export const SET_DIALOG_DATA = 'camera/SET_DIALOG_DATA'

export var RESET = 'camera/RESET';
export var setAnalyticCameraList = function setAnalyticCameraList(data) {
  return {
    type: SET_ANALYTIC_CAMERA_LIST,
    data: data
  };
};
export var setCctvCameraList = function setCctvCameraList(data) {
  return {
    type: SET_CCTV_CAMERA_LIST,
    data: data
  };
};
export var setRoadCameraList = function setRoadCameraList(data) {
  return {
    type: SET_ROAD_CAMERA_LIST,
    data: data
  };
};
export var setNvrList = function setNvrList(data) {
  return {
    type: SET_NVR_LIST,
    data: data
  };
};
export var setTipcCctvCameraList = function setTipcCctvCameraList(data) {
  return {
    type: SET_TIPC_CCTV_CAMERA_LIST,
    data: data
  };
};
export var setNvrOptions = function setNvrOptions(data) {
  return {
    type: SET_NVR_OPTIONS,
    data: data
  };
};
export var setHarborOptions = function setHarborOptions(data) {
  return {
    type: SET_HARBOR_OPTIONS,
    data: data
  };
};
export var setAnalyticCameraSort = function setAnalyticCameraSort(sort) {
  return {
    type: SET_ANALYTIC_CAMERA_SORT,
    sort: sort
  };
};
export var setCctvSort = function setCctvSort(sort) {
  return {
    type: SET_CCTV_SORT,
    sort: sort
  };
};
export var setRoadSort = function setRoadSort(sort) {
  return {
    type: SET_ROAD_SORT,
    sort: sort
  };
};
export var setNvrSort = function setNvrSort(sort) {
  return {
    type: SET_NVR_SORT,
    sort: sort
  };
};
export var setTipcSort = function setTipcSort(sort) {
  return {
    type: SET_TIPC_SORT,
    sort: sort
  };
};
export var setNvrIp = function setNvrIp(data) {
  return {
    type: SET_NVR_IP,
    data: data
  };
};
export var setDialogInfo = function setDialogInfo(data) {
  return {
    type: SET_DIALOG_INFO,
    data: data
  };
};
export var clearDialogInfo = function clearDialogInfo() {
  return {
    type: CLEAR_DIALOG_INFO
  };
}; // export const setOpenAnalyticCameraEdit = data => ({
//     type: OPEN_ANALYTIC_CAMERA_EDIT,
//     data
// })
// export const setDialogMode = data => ({
//     type: SET_DIALOG_MODE,
//     data
// })
// export const setDialogData = data => ({
//     type: SER_DIALOG_DATA,
//     data
// })

export var reset = function reset() {
  return {
    type: RESET
  };
};
var initDialogInfo = {
  // mode : analyticCamera.create, analyticCamera.edit, cctv.create, cctv.edit, road.detail, nvr.create, nvr.edit
  // other mode: traffic analysis vds
  mode: '',
  data: {}
};
var initialState = fromJS({
  analyticCameraList: [],
  cctvCameraList: [],
  roadCameraList: [],
  nvrList: [],
  tipcCctvCameraList: [],
  // selector Options
  nvrOptions: [],
  harborOptions: [],
  // table sort
  analyticCameraSort: {
    field: 'name',
    desc: false
  },
  cctvSort: {
    field: 'name',
    desc: false
  },
  roadSort: {
    field: 'name',
    desc: false
  },
  nvrSort: {
    field: 'name',
    desc: false
  },
  tipcSort: {
    field: 'name',
    desc: false
  },
  nvrIp: '',
  dialogInfo: initDialogInfo // openAnalyticCameraEdit: false

});
export default function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SET_ANALYTIC_CAMERA_LIST:
      return state.set('analyticCameraList', fromJS(action.data));

    case SET_CCTV_CAMERA_LIST:
      return state.set('cctvCameraList', fromJS(action.data));

    case SET_ROAD_CAMERA_LIST:
      return state.set('roadCameraList', fromJS(action.data));

    case SET_NVR_LIST:
      return state.set('nvrList', fromJS(action.data));

    case SET_TIPC_CCTV_CAMERA_LIST:
      return state.set('tipcCctvCameraList', fromJS(action.data));

    case SET_NVR_OPTIONS:
      return state.set('nvrOptions', fromJS(action.data));

    case SET_HARBOR_OPTIONS:
      return state.set('harborOptioins', fromJS(action.data));

    case SET_ANALYTIC_CAMERA_SORT:
      return state.set('analyticCameraSort', fromJS(action.sort));

    case SET_CCTV_SORT:
      return state.set('cctvSort', fromJS(action.sort));

    case SET_ROAD_SORT:
      return state.set('roadSort', fromJS(action.sort));

    case SET_NVR_SORT:
      return state.set('nvrSort', fromJS(action.sort));

    case SET_TIPC_SORT:
      return state.set('tipcSort', fromJS(action.sort));

    case SET_DIALOG_INFO:
      return state.set('dialogInfo', fromJS(action.data));

    case CLEAR_DIALOG_INFO:
      return state.set('dialogInfo', fromJS(initDialogInfo));

    case SET_NVR_IP:
      return state.set('nvrIp', fromJS(action.data));
    // case OPEN_ANALYTIC_CAMERA_EDIT:
    //     return state.set('openAnalyticCameraEdit', fromJS(action.data))
    // case SET_DIALOG_MODE:
    //     return state.set('dialogMode', action.data)
    // case SET_DIALOG_DATA:
    //     return state.set('dialogData', action.data)

    case RESET:
      return initialState;

    default:
      return state;
  }
}